import React from 'react';
import PropTypes from 'prop-types';

import { Permissions } from '@src/global/permissions';

import Grid from '@mui/material/Grid';
import get from 'lodash/get';
import {
    BooleanInput,
    SelectInput,
    DateInput,
} from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';

import { StyledSelectArrayInput } from '@src/custom';
import { validateFeedChannels } from '@src/validations';
import { FeedItemSource as source, FeedItemPriorities, FeedItemChannels } from './data';

const getEnabled = (formData) => get(formData, source.enabled);
const getPriority = (formData) => get(formData, source.priority);
const getChannels = (formData) => get(formData, source.channels);

const hasChannels = (formData) => {
    const channels = getChannels(formData) || [];
    return (channels && channels.length >= 1);
};

const channelNames = () => {
    return FeedItemChannels.map((channel) => channel.name);
};

const FeedInputs = (props) => {
    const { children, resource, ...rest } = props;
    const { control, setValue } = useFormContext();
    const formData = useWatch({ control });

    const handleEnabledChange = React.useCallback((value) => {
        if (!value || getPriority(formData) || hasChannels(formData)) {
            return null;
        }

        setValue(source.priority, 'low');
        setValue(source.channels, channelNames());
    }, [formData, setValue]);

    if (Permissions(resource, 'set_rss') === false) {
        return null;
    }

    return (
        <>
            <Grid>
                <BooleanInput
                    label="Add to RSS feed?"
                    source={source.enabled}
                    onChange={handleEnabledChange}
                    {...rest}
                />
            </Grid>
            <Grid>
                <DateInput
                    disabled={!getEnabled(formData)}
                    label="RSS Expiration Date"
                    source={source.expiredAt}
                    style={{ minWidth: '150px' }}
                    {...rest}
                />
            </Grid>
            <Grid>
                <SelectInput
                    allowEmpty={false}
                    disabled={!getEnabled(formData)}
                    label="Feed Priority"
                    source={source.priority}
                    choices={FeedItemPriorities}
                    {...rest}
                />
            </Grid>
            <Grid>
                <StyledSelectArrayInput
                    disabled={!getEnabled(formData)}
                    label="Feed Channels"
                    source={source.channels}
                    choices={FeedItemChannels}
                    validate={validateFeedChannels}
                    sx={{ width: '200px' }}
                    {...rest}
                />
            </Grid>
        </>
    );
};

FeedInputs.propTypes = {
    children: PropTypes.node,
    resource: PropTypes.string,
};

export default FeedInputs;
